<app-title title=" {{ 'PAGINA_LISTAR_PLANOS.TITULO' | translate }}"></app-title>
<section>
  <form [formGroup]="filtroForm" class="n-form" (ngSubmit)="buscarPlanos()">
    <div
      class="n-container p-5 n-card2 flex flex-wrap flex-column md:flex-row md:justify-content-between row-gap-5 column-gap-4"
    >
      <p-floatLabel>
        <p-inputNumber inputId="integeronly" formControlName="id" id="id" />
        <label for="Id" class="ng-invalide">
          {{ 'PAGINA_LISTAR_PLANOS.ID' | translate }}</label
        >
      </p-floatLabel>
      <p-floatLabel>
        <input pInputText id="username" formControlName="nome" />
        <label for="username" class="ng-invalide">
          {{ 'PAGINA_LISTAR_PLANOS.NOME' | translate }}</label
        >
      </p-floatLabel>

      <p-button label="Pesquisar" type="submit" />
    </div>
  </form>
</section>
<section class="section-margin">
  <div class="n-container p-5 n-card2">
    <div>
      <div class="flex justify-content-end">
        <button
          type="button"
          pButton
          pRipple
          icon="pi pi-plus"
          (click)="showAddPlanoDialog()"
        ></button>
      </div>
      <p-table [value]="planos" [tableStyle]="{'min-width': '50rem'}">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th>{{ 'PAGINA_LISTAR_PLANOS.ID' | translate }}</th>
            <th>{{ 'PAGINA_LISTAR_PLANOS.NOME' | translate }}</th>
            <th>{{ 'PAGINA_LISTAR_PLANOS.APLICACAO' | translate }}</th>
            <th>{{ 'PAGINA_LISTAR_PLANOS.ACOES' | translate }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-sistema let-columns="columns">
          <tr>
            <td>{{sistema.id}}</td>
            <td>{{sistema.nome}}</td>
            <td>{{sistema.aplicacao}}</td>
            <td>
              <button
                type="button"
                pButton
                pRipple
                icon="pi pi-pencil"
                (click)="selectSistema(sistema)"
              ></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</section>

<!-- Modal Adicionar funcionaliade -->

<p-dialog
  header="Adicionar plano"
  [modal]="true"
  [(visible)]="showAddPlano"
  [style]="{ width: '25rem' }"
>
  <form [formGroup]="formAddPlano" (ngSubmit)="salvarPlano()">
    <div class="flex align-items-center gap-3 mb-3">
      <p-floatLabel>
        <input pInputText id="nome" formControlName="nome"/>
        <label for="id" class="ng-invalide"
          >{{ 'PAGINA_PLANO.NOME' | translate }}</label
        >
      </p-floatLabel>
    </div>
    <div class="flex align-items-center gap-3 mb-5">
      <p-floatLabel>
        <p-inputNumber
          inputId="integeronly"
          formControlName="aplicacao"
          id="aplicacao"
        />
        <label for="aplicacao" class="ng-invalide"
          >{{ 'PAGINA_PLANO.APLICACAO' | translate }}</label
        >
      </p-floatLabel>
    </div>
    <div class="flex align-items-center gap-3 mb-3">
      <p-dropdown
      [options]="simNaoConst"
      formControlName="status"
      optionValue="value"
      optionLabel="description"
      placeholder="{{ 'PAGINA_PLANO.STATUS' | translate }}"
      [showClear]="true"
    />
    </div>
    <div class="flex justify-content-end gap-2">
      <p-button
        label="Cancel"
        severity="secondary"
        (onClick)="showAddPlano = false"
      />
      <p-button label="Save" type="submit" (onClick)="showAddPlano = false" />
    </div>
  </form>
</p-dialog>
